const baseURL = 'https://tienda.juguetekids.com.pe/';

export default baseURL;
